export default "__VITE_PUBLIC_ASSET__754991af__"